import { ChangeEvent } from "react";

import { Button } from "@vimeo/iris/components";
import { Image } from "@vimeo/iris/icons";

import "./fileupload.scoped.scss";

interface Props {
    onChange: (e: ChangeEvent) => void;
    mimeTypes: string;
}

export function FileUpload(props: Props) {
    const { onChange, mimeTypes } = props;

    return (
        <div className="slds-file-selector slds-file-selector_files">
            <div className="slds-file-selector__dropzone">
                <input
                    type="file"
                    className="slds-file-selector__input slds-assistive-text"
                    accept={mimeTypes}
                    id="file-upload-input"
                    aria-labelledby="file-selector-secondary-label"
                    onChange={onChange}
                />
                <label
                    className="slds-file-selector__body"
                    htmlFor="file-upload-input"
                    id="file-selector-secondary-label"
                >
                    <Button
                        element="span"
                        className="upload-button"
                        format="secondary"
                        icon={<Image />}
                        iconPosition="left"
                    >
                        Upload
                    </Button>
                </label>
            </div>
        </div>
    );
}
